import React, {useState} from "react";
import EditIcon from "@mui/icons-material/Edit";
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import {t} from "i18next";
import {ColorResult, SketchPicker} from "react-color";
import CustomDialog from "../custom-dialog";

interface ColorPickerProps {
  value: string;
  onChange: (value: string, rawColor?: ColorResult) => void;
  label?: string;
  dialogTitle?: string;
  formatColor?: (color: ColorResult) => string;
}

interface PickerProps {
  color: string;
  onChange: (color: ColorResult) => void;
}

const ColorPicker = ({value, onChange, label, dialogTitle, formatColor, colorFormat}: ColorPickerProps) => {
  const [isDialogOpen, setDialogOpen] = useState(false);

  const defaultFormatColor = (color: ColorResult) =>
    colorFormat === "hex" ? color.hex : `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`;

  const handleColorChange = (color: ColorResult) => {
    const formatted = (formatColor || defaultFormatColor)(color);
    onChange(formatted, color);
  };

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      {label && <Typography style={{fontSize: 16}}>{label}</Typography>}

      <Box
        sx={{
          mx: 2,
          width: 170,
          height: 40,
          background: value,
          border: "1px solid black",
          borderRadius: 1,
          cursor: "pointer"
        }}
        onClick={() => setDialogOpen(true)}
      />

      <EditIcon style={{cursor: "pointer"}} onClick={() => setDialogOpen(true)} />

      <CustomDialog open={isDialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm">
        {dialogTitle && <DialogTitle>{dialogTitle}</DialogTitle>}
        <DialogContent style={{padding: 0}}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <SketchPicker color={value} onChange={handleColorChange} />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>{t("commons.confirm.close")}</Button>
        </DialogActions>
      </CustomDialog>
    </Box>
  );
};

export default ColorPicker;
